import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatIconModule, MatInputModule, MatRadioModule, MatSelectModule } from '@angular/material';
import { CopyDialogComponent } from './copy-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule
  ],
  declarations: [CopyDialogComponent],
  entryComponents: [CopyDialogComponent],
  exports: [CopyDialogComponent]
})
export class CopyDialogModule {
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/copy-dialog/copy-dialog.module.ts